import React, { useEffect, useState } from "react";
import "./Teething.css";
import { teeth_images, teeth_rgt_side } from "assets/icons";
import useFullPageLoader from "common/UseFullPageLoader";
import { teethTrackingListApi } from "services/teethTracking";
import { firstWordCapital } from "utils/common";
import { dateFormatWithTime } from "utils/dateFormat";

const Teething = ({ _child }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [trackingList, setTrackingList] = useState([]);
  const [meta, setMeta] = useState({});

  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await teethTrackingListApi({ childId: _child, limit: 5000 });
      if (status === 200) {
        setTrackingList(data?.data);
        setMeta(data?.meta);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="teething_parent">
        <div className="teething_wraper">
          {/* cardss */}

          <div className="row">
            <h6 className="teeth_history">Teeth logs history</h6>
            <div className="col-lg-4 col-md-5 col-sm-6  ">
              <div className="teeth_card">

                {
                  trackingList.map((teeth, i) => {
                    return <div className="teeth_wraper" key={i}>
                      <div className="teeth_lft">
                        <h6>{`${teeth.name} (${firstWordCapital(teeth?.direction?.toLowerCase())})`}</h6>
                        <div className="time_wraper">
                          <span className="datee">{dateFormatWithTime(teeth?.createdAt)}</span>
                        </div>
                      </div>

                      <div className={i % 2 ? "teeth_rgt" : "teeth_rgt bg_pink"}>
                        <img src={teeth_images} />
                      </div>
                    </div>
                  })
                }
              </div>
            </div>

            <div className="col-lg-8 col-md-7 col-sm-6 ">
              <div className="rgt_teeth_img">
                <img src={teeth_rgt_side} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Teething;
